import React from "react";
import { CDP_CARD_KEYS } from "./constants";

export const getCdpPageSection = (cmsConfig, isInternalListing) => {
    if (!cmsConfig?.data?.pageSections) return null;
    const sectionName = isInternalListing ? "CAR_DETAILS_DWEB_ORDER" : "CAR-DETAILS-DWEB-ORDER-DEALER";

    const section = cmsConfig.data.pageSections.find(
        s => s.pageSection?.name === sectionName
    );

    return section?.pageSection || null;
};

export const parseCdpConfig = (pageSection) => {
    if (!pageSection?.meta) return null;

    try {
        const config = pageSection.meta;
        return config;
    } catch (error) {
        return null;
    }
};

export const getCardBusinessVisibility = (cardKey, context) => {
    switch (cardKey) {
    case CDP_CARD_KEYS.CAR_HISTORY_BANNER:
        return !!context.chrMediumBannerSection;
    case CDP_CARD_KEYS.CAR_PRICE_GUIDE:
        return !!context.showKBB;
    case CDP_CARD_KEYS.CAR_CONDITION:
        return context.isInternalListing;

    case CDP_CARD_KEYS.DEALER_COMMENTS:
    case CDP_CARD_KEYS.DEALER_VERIFICATION:
        return context.isDealerListing;
    case CDP_CARD_KEYS.PREMIUM_FEATURES:
        return context.content?.features?.premiumWithIcons?.length > 0;

    default:
        return true;
    }
};

// Helper function 4: Calculate visible cards order
export const calculateCdpCardOrder = (config, context) => {
    if (!config?.cards) return [];

    const visibleCards = [];

    config.cards.forEach((card) => {
        // Layer 1: CMS toggle
        if (!card.visible) return;

        // Layer 2: Business logic visibility
        if (!getCardBusinessVisibility(card.key, context)) return;

        visibleCards.push(card);
    });

    // Ensure price history shows up if available but not configured in CMS
    const hasPriceHistoryCard = visibleCards.some(c => c.key === CDP_CARD_KEYS.PRICE_HISTORY_REPORT);
    if (!hasPriceHistoryCard && context?.content?.carPriceHistory) {
        visibleCards.push({ key: CDP_CARD_KEYS.PRICE_HISTORY_REPORT, visible: true });
    }

    return visibleCards;
};
